<template>
    <div style="height: 80px;"></div>
    <div v-if="state.rodo == 'show'" class="rodo">
        <svg @click="rodoClose" width="32px" height="32px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" class="close">
            <polyline points="4,4 44,44" fill="none" stroke-width="5" stroke="black" stroke-linecap="round"/>
            <polyline points="4,44 44,4" fill="none" stroke-width="5" stroke="black" stroke-linecap="round"/>
        </svg>
        <div class="content">
            <p>Szanowni Państwo,</p>
            <p>Administratorem Państwa danych jest Wioletta Nowak prowadząca działalność gospodarczą pod nazwą:</p>
            <p>Biuro Nieruchomości „ARA” Wioletta Nowak przy ul. Michałowskiego 12 lok. 91,</p>
            <p>42-224 Częstochowa,</p>
            <p>NIP 9490875910,</p>
            <p>REGON 243660277,</p>
            <p>(dalej: „Biuro Nieruchomości”).</p>
            <p>Podane przez Państwa dane osobowe będą przetwarzane w następujących celach:</p>
            <ul>
                <li>realizacji umowy, którą zawarli Państwo z Biurem Nieruchomości - na podstawie art. 6 ust. 1 lit. b) Ogólnego rozporządzenia o ochronie danych (zwanego dalej „RODO”) - przetwarzanie jest niezbędne do wykonania umowy, do czasu zakończenia umowy</li>
                <li>przesyłania informacji handlowych za pomocą środków komunikacji elektronicznej – na podstawie art. 6 ust. 1 lit. a) RODO – zgody, do momentu cofnięcia zgody;</li>
                <li>marketingu bezpośredniego - na podstawie art. 6 ust. 1 lit. a) RODO - zgody, do momentu cofnięcia zgody;</li>
                <li>finansowo – księgowych - na podstawie art. 6 ust. 1 lit. c) RODO - przetwarzanie jest</li>
                <li>niezbędne do wykonania przepisów prawa m.in. podatkowych, do czasu wymaganego</li>
                <li>właściwymi przepisami prawa podatkowego;</li>
                <li>obrony przez roszczeniami i dochodzenia roszczeń - na podstawie art. 6 ust. 1 lit. b) RODO - przetwarzanie jest niezbędne do wykonania umowy, do czasu wygaśnięcia okresu roszczeń zgodnie z Kodeksem Cywilnym;</li>
            </ul>
            <p>W związku z celami, o których mowa powyżej, odbiorcą Państwa danych osobowych mogą być podmioty pośredniczące w wykonaniu umowy (np. inne agencje pośrednictwa sprzedaży nieruchomości), a także podmioty pośredniczące w działaniach wykonywanych przez administratora, np. dostawcy usług IT, kancelarie prawne.</p>
            <p>Posiadają Państwo prawo do cofnięcia zgody w dowolnym momencie. W celu cofnięcia zgody mogą się Państwo skontaktować z Biurem Nieruchomości pod adresem Michałowskiego 12lok.91, 42-224 Częstochowa lub wysyłając maila na adres: nieruchomosciara@gmail.com</p>
            <p>Cofnięcie zgody nie będzie wpływać na zgodność z prawem przetwarzania, którego dokonano na podstawie Państwa zgody przed jej wycofaniem.</p>
            <p>Posiadają Państwo prawo dostępu do treści swoich danych oraz prawo ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo do przenoszenia danych, prawo wniesienia sprzeciwu (np. jeśli dane są przetwarzane w celach marketingowych). Mają Państwo prawo wniesienia skargi do organu nadzorczego - Prezesa Urzędu Ochrony Danych Osobowych (poprzednio GIODO).</p>
            <p>
                <u>Podanie przez Państwa danych osobowych jest w pełni dobrowolne. Niepodanie danych osobowych będzie skutkowało niemożliwością zawarcia umowy pośrednictwa w obrocie nieruchomościami.</u>
            </p>
        </div>
    </div>
    <NavBar/>
    <div class="content">
        <router-view v-slot="{ Component }" :key="$route.fullPath">
            <transition name="fade" mode="out-in">
                <component :is="Component"/>
            </transition>
        </router-view>
    </div>
    <Footer/>
</template>

<script lang="ts">
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import {useState} from "@/state";

const clearCookies = () => {
    for (let cookie of document.cookie.split(';')) {
        document.cookie = cookie + "=;expires=" + new Date(0).toUTCString();
    }
};

const getCookies = () => {
    if (!document.cookie.trim().length) {
        return 1;
    }
    let cookies = {};
    for (let cookie of document.cookie.split(';')) {
        let [name, val] = cookie.split("=");
        cookies[name.trim()] = val.trim();
    }
    return cookies;
};

const setCookie = (name, value) => {
    document.cookie = `${name}=${value}`;
};

export default {
    name: 'App',
    components: {
        Footer,
        NavBar
    },
    data() {
        return {
            state: useState()
        }
    },
    methods: {
        rodoClose() {
            this.state.rodo = 'hide';
            setCookie('rodo', 'hide')
        }
    },
    mounted() {
        if (/bot|crawl|slurp|spider|mediapartners/i.test(navigator.userAgent)) {
            this.state.rodo = 'hide';
        } else {
            this.state.rodo = getCookies().rodo || 'show';
        }
    }
}
</script>

<style lang="scss">
:root {
    --red: #ff1111;
    --white: #ffffff;
    --button-red: #ff1111;
    --button-gray: #aaaaaa;
    --border-color: #aaaaaa;
    --border-collor-active: #ff1111;
}

* {
    box-sizing: border-box;
    //position: relative;
    outline: none;
}

body {
    margin: 0;
    padding: 0;
}

.fade-enter-active,
.fade-leave-active {
    //transition: height 300ms ease, opacity 300ms ease;
    transition: all 300ms ease-in-out;
    opacity: 1;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    //transform: translateX(-100px);
}

//.fade-enter-to,
//.fade-leave-from {
//    opacity: 1;
//    transform: translateX(0px);
//}

.rodo {
    ::-webkit-scrollbar {
        width: 8px;
        border-radius: 4px;
    }

    ::-webkit-scrollbar-track {
        background-color: rgba(#000000, .1);
        border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;

        &:hover {
            background: #555;
        }
    }

    position: fixed;
    display: block;
    z-index: 1000;
    bottom: 0;
    left: 10vw;
    width: 80vw;
    height: 30vh;
    background-color: rgba(#000000, .8);
    color: #eeeeee;

    div.content {
        font: 16px/24px "Roboto Condensed";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100% - 2vw);
        margin-top: 1vw;
        margin-bottom: 1vw;
        padding: 0 10vw 0 1vw;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    svg.close {
        display: block;
        position: absolute;
        top: 1vw;
        right: 1vw;
        z-index: 10;
        cursor: pointer;

        * {
            fill: #eeeeee;
            stroke: #eeeeee;
        }
    }
}

@mixin includeFont($weight, $fontName, $fontDir, $fileName) {
    @font-face {
        font-family: '#{$fontName}';
        font-style: normal;
        font-weight: $weight;
        src: local('$fontName'),
        url(#{$fontDir}#{$fileName}.woff2) format('woff2'),
        url(#{$fontDir}#{$fileName}.woff) format('woff'),
        url(#{$fontDir}#{$fileName}.svg) format('svg'),
        url(#{$fontDir}#{$fileName}.ttf) format('truetype'),
        url(#{$fontDir}#{$fileName}.eot) format('embedded-opentype');
    }
}

@include includeFont(300, 'Google Sans', '/assets/font/', 'GoogleSansRegular');
@include includeFont(300, 'Roboto Condensed', '/assets/font/', 'robotocondensed-regular');

</style>
